module.exports = __webpack_public_path__ + "static/media/led.1b1ac0c5.svg";